/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

export const RawHtml = ({ children }) => (<div dangerouslySetInnerHTML={{ __html: children }} />);

RawHtml.propTypes = {
  children: PropTypes.string,
};

RawHtml.defaultProps = {
  children: '',
};
